import { render } from "./ForgotPassword.vue?vue&type=template&id=54238c46&scoped=true&ts=true"
import script from "./ForgotPassword.ts?vue&type=script&lang=ts&external"
export * from "./ForgotPassword.ts?vue&type=script&lang=ts&external"

import "./ForgotPassword.scss?vue&type=style&index=0&id=54238c46&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54238c46"]])

export default __exports__